export const DIENSTLEISTUNG_CODE_REGEX = /^\d{6}_[A-Z]{5}$/;

export function istCodeValid(input: string): boolean {
  return DIENSTLEISTUNG_CODE_REGEX.test(input);
}

export const DIENSTLEISTUNG_CODE_FORMAT_MESSAGE =
  'Der Code besteht aus 6 numerischen Zeichen einem "_" und 5 Grossbuchstaben (z.B. 018659_CAEFY)';
